import { render, staticRenderFns } from "./Consultorios.vue?vue&type=template&id=147961a8&scoped=true&"
import script from "./Consultorios.vue?vue&type=script&lang=js&"
export * from "./Consultorios.vue?vue&type=script&lang=js&"
import style0 from "./Consultorios.vue?vue&type=style&index=0&id=147961a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147961a8",
  null
  
)

export default component.exports